import {
    makeButtonsVisible,
    copyLinkToShare,
    isElementVisible,
    chartAutoProgress,
    numberAutoCounter,
    gimmemoreDesktopNav,
    lifelinesModal,
    toggleText,
    accordionButtonsHandler,
    shareModalHandler,
    playAgainUrlHandler,
    showItemsListWithDelay
} from "./js/functions";
import {videoQuestionSetup} from "./js/video";

document.addEventListener('DOMContentLoaded', () => {
    // nav
    let $navBtn = document.querySelector('.nav-btn');
    let $mobileNav = document.querySelector('.nav-mobile');

    if (!!$navBtn && !!$mobileNav) {
        $navBtn.addEventListener('click', (e) => {
            e.preventDefault();

            if ($navBtn.classList.contains('active')) {
                $navBtn.classList.remove('active');
                $mobileNav.classList.remove('open');
            } else {
                $navBtn.classList.add('active');
                $mobileNav.classList.add('open');
            }
        });
    }

    let $intellitestNav = document.querySelector('.nav-close');
    if ($intellitestNav) {
        $intellitestNav.addEventListener('click', (e) => {
            e.preventDefault();

            document.querySelector('.nav-mobile').classList.remove('open');
            document.querySelector('.nav-btn').classList.remove('active');
        });
    }

    const onViewportChange = () => {
        if (document.querySelector('.intellitest-theme')) { return; }

        if (document.documentElement.scrollTop > 0) {
            return $mobileNav.style.top = '0px';
        }

        const offsetHeight = document.querySelector('header').offsetHeight - 1;

        $mobileNav.style.top = offsetHeight + 'px';
    }

    if (isElementVisible($navBtn)) {
        document.addEventListener('scroll', () => onViewportChange());
    }

    // share
    let $shareBtn = document.querySelectorAll('.share-btn');
    let $shareContainer = document.querySelector('.share-container');
    let $shareContainerCloseBtn = document.querySelector('.share-container .close');
    let $quickShare = document.querySelector('.quick-share');

    if (!!$shareBtn) {
        $shareBtn.forEach((btn) => {
            btn.addEventListener('click', (e) => {
                if (!$shareContainer.classList.contains('open')) {
                    $shareContainer.classList.add('open');
                }
            });
        });
    }

    if (!!$shareContainerCloseBtn) {
        $shareContainerCloseBtn.addEventListener('click', (e) => {
            if ($shareContainer.classList.contains('open')) {
                $shareContainer.classList.remove('open');
            }
        });
    }

    if (!!$quickShare) {
        $quickShare.addEventListener('click', (e) => {
            if (!!$shareContainer && !$shareContainer.classList.contains('open')) {
                $shareContainer.classList.add('open');
            }
        });
    }

    copyLinkToShare();

    // loader
    let $loader = document.querySelector('.loader');
    let $contentToLoad = document.querySelectorAll('.content-is-loading');

    if (!!$loader && !!$contentToLoad) {
        $contentToLoad.forEach((container) => {
            const timer = parseInt(container.getAttribute('data-delay')) * 1000;
            setTimeout(() => {
                container.classList.remove('content-is-loading');
                $loader.classList.add('hide');
            }, timer);
        });
    }

    // buttons with delay
    makeButtonsVisible();

    // score chart
    chartAutoProgress();
    numberAutoCounter('js-counter');

    // gimmemore desktop nav
    gimmemoreDesktopNav();

    // video question
    videoQuestionSetup();

    // lifelines modal
    lifelinesModal();

    // less-more text option
    toggleText();

    // complete page UI
    accordionButtonsHandler();

    // share modal
    shareModalHandler();

    // play again
    playAgainUrlHandler();

    // display list items one by one with delay
    showItemsListWithDelay();
});